<template lang="pug">
.container.grid-xl
  page-title(
    title='Importações em CSV',
    icon='fas fa-file-csv',
    subtitle='Upload de CSV para importação de dados'
  )
    div(slot="actions")
      a.btn.btn-primary(@click="modalActive = true")
        i.fas.fa-upload
        |  Enviar CSV
  form-modal(:active="modalActive" @close="modalActive = false" @uploaded="onUploaded")
  list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
    table.table.text-small(v-if="list")
      thead
        tr
          th(width="200px") Nome do arquivo
          th(width="150px") Tam. do arquivo
          th(width="100px") Status
          th.text-right(width="1") Ações
      tbody
        tr(v-for="row in list.rows" :title="`Enviado por ${row.author.fullName}`")
          td.text-ellipsis {{ row.fileName }}
          td {{ Math.round(row.fileSize / 1000) }} kb
          td(:class="getStatus(row.status).textClass") {{ getStatus(row.status).description }}
          td.text-right
            router-link.btn.btn-sm.btn-action.btn-primary(:to="{name: 'import-csvs.show', params: {id: row.id}}")
              i.fas.fa-eye

</template>

<script>
import importCsvs from '@/services/importCsvs'
import { IMPORT_CSV_STATUS } from '@/config/constants'
import FormModal from './Form.vue'

export default {
  data() {
    return { loading: false, error: null, list: null, modalActive: false }
  },
  components: { FormModal },
  methods: {
    getStatus(status) {
      return IMPORT_CSV_STATUS[status] || {}
    },
    onUploaded(register) {
      if (!this.list) this.fetchData()
      else this.list.rows = [register, ...this.list.rows]
      this.modalActive = false
      this.$toaster.success('Arquivo enviado')
    },
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await importCsvs.list({ ...params })
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    const params = this.$route.query
    this.fetchData(params)
  },
}
</script>
